import { RestService } from './restService';
import { TagMetadata } from '../models/tagMetadata';

export class TagMetadataService extends RestService<TagMetadata> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }
}
